import { MeDto } from '../../../models/dtos/me.dto';
import axios from '../../axios';

export default async function getUserInfoRequest(): Promise<MeDto> {
  const response = await axios.get<MeDto>(
    `${process.env.REACT_APP_BASE_URL}/users/info`
  );
  return response.data;
}
